import { useEffect } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $getSelection, $isRangeSelection, PASTE_COMMAND, COMMAND_PRIORITY_HIGH} from "lexical"
import { $createYouTubeNode } from "../nodes/youtubeNode"


function extractYouTubeVideoId(url: string): string | null {
  try {
    const urlObj = new URL(url)
    if (urlObj.hostname.includes("youtube.com")) {
      return urlObj.searchParams.get("v")
    }

    if (urlObj.hostname.includes("youtu.be")) {
      return urlObj.pathname.slice(1)
    }

    if (urlObj.pathname.includes("/embed/")) {
      const match = urlObj.pathname.match(/\/embed\/([^/?]+)/)
      return match ? match[1] : null
    }
  } catch {
    
  }

  return null
}


export function PasteYouTubePlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unregister = editor.registerCommand(
      PASTE_COMMAND,
      (event: ClipboardEvent) => {
        let pastedText = "";

        // Get plain text only
        if (typeof event === "string") {
          pastedText = event;
        } else if (event?.clipboardData) {
          pastedText = event.clipboardData.getData("text/plain");
        }

        const videoId = extractYouTubeVideoId(pastedText);
        if (!videoId) return false; // let default paste handle non-YouTube links

        event.preventDefault();

        editor.update(() => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            selection.removeText();
            const youtubeNode = $createYouTubeNode({ videoId });
            selection.insertNodes([youtubeNode]);
          }
        });

        return true; // stop default paste
      },
      COMMAND_PRIORITY_HIGH
    );

    return () => unregister();
  }, [editor]);

  return null;
}

// export function PastePlugin(): null {
//   const [editor] = useLexicalComposerContext()

//   useEffect(() => {
//     const handlePaste = (event: ClipboardEvent) => {
//       const clipboardData = event.clipboardData
//       if (!clipboardData) return

//       const text = clipboardData.getData("text/plain")

//       const videoId = extractYouTubeVideoId(text)

//       if (videoId) {
//         event.preventDefault()
//         event.stopPropagation()

//         editor.update(() => {
//           const selection = $getSelection()

//           if ($isRangeSelection(selection)) {
//             selection.removeText()
//           }

//           const youtubeNode = $createYouTubeNode({ videoId })
//           // const paragraph = $createParagraphNode()
//           // paragraph.append(youtubeNode)
//           $insertNodes([youtubeNode]);

//           // selection?.insertNodes([paragraph])
//         })
//         return
//       }
//     }

//     const contentEditableElement = editor.getRootElement()
//     if (contentEditableElement) {
//       contentEditableElement.addEventListener("paste", handlePaste)

//       return () => {
//         contentEditableElement.removeEventListener("paste", handlePaste)
//       }
//     }
//   }, [editor])

//   return null
// }

// export function PasteYouTubePlugin(): null {
//   const [editor] = useLexicalComposerContext();

//   useEffect(() => {

//     const unregister = editor.registerCommand(
//       PASTE_COMMAND,
//       (event) => {
//         let textPlain = "";
//         let html = "";

//         try {
//           if (typeof event === "string") {
//             textPlain = event;
//           } else if (event && typeof event === "object") {
//             const clipboard = (event as ClipboardEvent).clipboardData;
//             if (!clipboard) return false;
//             textPlain = clipboard.getData("text/plain") || "";
//             html = clipboard.getData("text/html") || "";
//           }
//         } catch (err) {
//           // ignore
//         }

//         // Prefer HTML (it may contain <a> or <iframe>), otherwise plain text
//         const candidates = [html, textPlain].filter(Boolean) as string[];

//         for (const candidate of candidates) {

//           let maybeUrl: string | null = null;

//           if (candidate.includes("<")) {
//             try {
//               const parser = new DOMParser();
//               const doc = parser.parseFromString(candidate, "text/html");
//               // check anchors
//               const a = doc.querySelector("a[href]");
//               if (a) maybeUrl = a.getAttribute("href");
//               // or iframes
//               if (!maybeUrl) {
//                 const iframe = doc.querySelector("iframe[src]");
//                 if (iframe) maybeUrl = iframe.getAttribute("src");
//               }
//             } catch (err) {
//               // ignore
//             }
//           }

//           // fallback: treat candidate as plain text and look for a URL substring
//           if (!maybeUrl) {
//             const urlMatch = candidate.match(/https?:\/\/[^\s'"]+/);
//             if (urlMatch) maybeUrl = urlMatch[0];
//           }

//           if (maybeUrl) {
//             const videoId = extractYouTubeVideoId(maybeUrl);
//             if (videoId) {

//               editor.update(() => {
//                 const selection = $getSelection();

//                 if ($isRangeSelection(selection)) {
//                   selection.removeText(); 
//                 }

//                 const youtubeNode = $createYouTubeNode({videoId});
//                 if ($isRangeSelection(selection)) {
//                   selection.insertNodes([youtubeNode]);
//                 } else {
//                   const paragraph = $createParagraphNode();
//                   paragraph.append(youtubeNode);
//                   $insertNodes([paragraph]);
//                 }
//               });

//               return true;
//             }
//           }
//         }

//         return false; 
//       },
//       COMMAND_PRIORITY_HIGH
//     );

//     return () => {
//       unregister();
//     };
//   }, [editor]);

//   return null;
// }